// src/index.js
import 'primereact/resources/themes/saga-blue/theme.css';   // wybrany motyw
import 'primereact/resources/primereact.min.css';           // style PrimeReact
import 'primeicons/primeicons.css';                         // ikony
import 'primeflex/primeflex.css';                           // opcjonalne utility CSS

import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { AuthProvider } from './context/AuthContext';
import './utils/api'; // Rejestracja globalnych interceptorów axios

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <AuthProvider>
      <App />
    </AuthProvider>
  </React.StrictMode>
);
